import { useState } from "react";
import { Bell, BellRing } from "lucide-react";
import { toast } from "sonner";
import { pushSupported, subscribePush } from "@/lib/push";

export default function NotificationBell() {
  const [enabled, setEnabled] = useState(
    pushSupported() && Notification.permission === "granted"
  );

  if (!pushSupported()) return null;

  const enable = async () => {
    try {
      await subscribePush();
      setEnabled(true);
      toast.success("Notifiche attivate su questo dispositivo");
    } catch (e) {
      if (e.message === "denied") toast.error("Permesso notifiche negato dal browser");
      else toast.error("Impossibile attivare le notifiche");
    }
  };

  return (
    <button
      data-testid="notification-bell-button"
      onClick={enabled ? undefined : enable}
      title={enabled ? "Notifiche attive" : "Attiva le notifiche di scadenza"}
      className={`p-1.5 transition-colors ${enabled ? "text-emerald-400 cursor-default" : "text-slate-500 hover:text-[#E3BC55]"}`}
    >
      {enabled ? <BellRing className="w-4 h-4" /> : <Bell className="w-4 h-4" />}
    </button>
  );
}
